import { jsx as _jsx } from "react/jsx-runtime";
import { ScreenFrame } from '../../screen/components/ScreenFrame';
import { PairingView } from '../../screen/components/PairingView';
import { IdleView } from '../../screen/components/IdleView';
import { MatchView } from '../../screen/components/MatchView';
import { useNow } from '../../screen/hooks/useNow';
import { useScreenPageSetup } from '../../screen/hooks/useScreenPageSetup';
import { useScreenSession } from '../../screen/hooks/useScreenSession';
import { backgrounds } from '../../screen/theme';
function ScreenContent({ view, nowSec }) {
    if (view.kind === 'pending')
        return _jsx(PairingView, { code: view.code, expiresAt: view.expiresAt, nowSec: nowSec });
    if (view.kind === 'active') {
        const { match, event } = view.data;
        return match ? _jsx(MatchView, { match: match, nowSec: nowSec }) : _jsx(IdleView, { event: event });
    }
    return _jsx("div", { style: { position: 'absolute', inset: 0, background: backgrounds.day } });
}
export function Screen() {
    useScreenPageSetup();
    const session = useScreenSession();
    const now = useNow();
    const nowSec = Math.floor((now + session.offsetMs) / 1000);
    return (_jsx(ScreenFrame, Object.assign({ offline: session.offline }, { children: _jsx(ScreenContent, { view: session.view, nowSec: nowSec }) })));
}
